import Icon from '@ant-design/icons/es/components/Icon';
import React from 'react';
import sparkIconWhite from 'images/sparkleIconWhite.svg';
import sparkleIcon from 'images/sparkleIcon.svg';
export const SparkleIcon = () => React.createElement(Icon, { component: () => React.createElement("img", { src: sparkleIcon }) });
export const SparkleIconWhite = () => React.createElement(Icon, { component: () => React.createElement("img", { src: sparkIconWhite }) });
